import type { NewsletterApiConfig, NewsletterApiHandler } from './types.js';

import { createNewsletterApiFetcher } from './fetch-newsletter-api.js';
import { console } from '../../../../src/core/system/console/console.client.js';

const initNewsletterApi = ({ baseUrl, disableCache }: NewsletterApiConfig) => {
  const fetchNewsletterApi = createNewsletterApiFetcher(baseUrl, disableCache);

  const subscribe: NewsletterApiHandler = async ({
    newsletterId,
    userToken,
  }) => {
    if (!userToken) return false;

    return fetchNewsletterApi({
      method: 'POST',
      path: `/${newsletterId}/subscribe`,
      sig: userToken,
    })
      .then((res) => res.message === 'success')
      .catch((err) => {
        console.error(`Newsletter API - subscribe: ${err}`);

        return false;
      });
  };

  const unsubscribe: NewsletterApiHandler = async ({
    newsletterId,
    userToken,
  }) => {
    if (!userToken) return false;

    return fetchNewsletterApi({
      method: 'POST',
      path: `/${newsletterId}/unsubscribe`,
      sig: userToken,
    })
      .then((res) => res.message === 'success')
      .catch((err) => {
        console.error(`Newsletter API - unsubscribe: ${err}`);

        return false;
      });
  };

  const getSubscriptionStatus: NewsletterApiHandler = async ({
    newsletterId,
    userToken,
  }) => {
    if (!userToken) return false;

    return fetchNewsletterApi({
      path: `/${newsletterId}`,
      sig: userToken,
    })
      .then((res) => res.subscribed)
      .catch((err) => {
        console.error(`Newsletter API - get subscription status: ${err}`);

        return false;
      });
  };

  return {
    subscribe,
    unsubscribe,
    getSubscriptionStatus,
  };
};

export { initNewsletterApi };
